import {registerBlockType} from "@wordpress/blocks"
const { RichText, InnerBlocks, InspectorControls, BlockControls, AlignmentToolbar, PanelColorSettings, FontSizePicker, MediaUpload, MediaUploadCheck } = wp.blockEditor;
const ALLOWED_BLOCKS=['spice-blocks/spice-button']
import { PanelBody, Button, ResponsiveWrapper, RangeControl, SelectControl, ToggleControl, TextControl, __experimentalBoxControl as BoxControl, BaseControl, FormToggle, FocalPointPicker} from '@wordpress/components';
const { Fragment } = wp.element;
const { __ } = wp.i18n;
const { withSelect } = wp.data;
import FontPicker from "./lib/FontPicker.js";

const BlockEdit = (props) => {	
	const { attributes, setAttributes, clientId } = props;
	const{ uniqueid, bgType, boxColor, quoteColor, shadowColor, subtitle, subtitlepaddings, subtitleborderRadius, titlepaddings, Title, subtitleColor, subtitlebgColor, bgColor, titleColor, bgimgrepeat, bgimgposition, bgimgsize, bgimgattch, margins, paddings, opacity, subtitlefontfamily,  subtitlefontSize, subtitleLineHeight, subtitleFontWeight, subtitleTransform, subtitleDecoration, subtitleLetterSpacing, titlefontfamily,  titlefontSize, titleFontWeight, titleLineHeight, titleTransform, titleDecoration, titleLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bgImage, bgImageParallax, bgImageSize, bgImageRepeat, bgImageOverlay, bgOverlayColor, bgOverlayPopup, bgOverlayOpacity, bgVideo, bgImagePosition, hideTitle, hidesubtitle}=attributes;		
	setAttributes({ uniqueid: 'spiceCTA' +clientId.slice(0,8) });	
	const blockStyle = plugin.pluginpath + 'assets/images/cta.jpg';
		
	function setSubtitle(value) {
		setAttributes({subtitleColor:value});
	}
	function setTitle(value) {
		setAttributes({titleColor:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	function setOverlayColor(value) {
		setAttributes({bgOverlayColor:value});
	}

	let containerBg = '';
	const bgImage1 =(bgImage !=null) ? bgImage : blockStyle;
	if (bgType !== 'none' && bgType === 'image') {
		containerBg = `url(${bgImage1})`;		
	} else {
		containerBg = `url(${blockStyle})`;
	}

	let backgroundPosition = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundPosition =`${bgImagePosition.x * 100}% ${ bgImagePosition.y * 100 }%`
	}
	else
	{
		backgroundPosition = '';
	}

	let backgroundSize = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundSize = bgImageSize;
	}
	else
	{
		backgroundSize = '';
	}

	//Image Background Attachment
	let backgroundAttachment = '';
	if(bgType === 'image' && bgImage && bgImageParallax)
	{
		backgroundAttachment='fixed';
	}
	else
	{
		backgroundAttachment='scroll';
	}	
	
	//Image Repeat
	let backgroundRepeat = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundRepeat = bgImageRepeat;
	}
	else
	{
		backgroundRepeat = '';
	}

	const blockquoteclass='wp-block background-img spice-blocks-cta';

	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop != false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet != false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile != false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
	
	if(titlefontfamily !=null){
		let url = 'https://fonts.googleapis.com/css2?family='+titlefontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }else{
      	document.head.appendChild(link);
      }
    }
    if(subtitlefontfamily !=null){
		let url = 'https://fonts.googleapis.com/css2?family='+subtitlefontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }else{
      	document.head.appendChild(link);
      }
    }
	return(
		<Fragment>			
			<style dangerouslySetInnerHTML={{
			  __html: [
			    `.spice-blocks-cta#${uniqueid}{
			     	background-image: ${containerBg};					
			    	margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
					padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
					box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
					animation-delay: ${delay}ms;
					background-position: ${backgroundPosition}; 
					background-repeat: ${bgImageRepeat};
					background-size:${backgroundSize};
					background-attachment: ${backgroundAttachment};
					background-repeat: ${backgroundRepeat};
					
			     }
			    #${uniqueid} .top-heading{
			     	color:${titleColor};
					font-size: ${titlefontSize};
					font-weight: ${titleFontWeight};
					line-height: ${titleLineHeight}px;
					font-family: ${titlefontfamily};
					text-transform: ${titleTransform};
					text-decoration: ${titleDecoration};
					letter-spacing: ${titleLetterSpacing}px;
					padding: ${titlepaddings.top} ${titlepaddings.right} ${titlepaddings.bottom} ${titlepaddings.left};
					}
			    #${uniqueid} p.main-heading{
						color:${subtitleColor};
						font-size: ${subtitlefontSize};
						font-weight: ${subtitleFontWeight};
						line-height: ${subtitleLineHeight}px;
						font-family: ${subtitlefontfamily};
						text-transform: ${subtitleTransform};
						text-decoration: ${subtitleDecoration};
						letter-spacing: ${subtitleLetterSpacing}px;
						padding: ${subtitlepaddings.top} ${subtitlepaddings.right} ${subtitlepaddings.bottom} ${subtitlepaddings.left};
				}`
			    ].join('\n')
			  }}>
			</style>
			<InspectorControls>
				<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>

					<ToggleControl
						label={__('Enable Title','spice-blocks')}
						checked={hideTitle}
						onChange={(newval) => setAttributes({ hideTitle: newval })}
					/>

					<ToggleControl
						label={__('Enable/Disable Subtitle','spice-blocks')}
						checked={hidesubtitle}
						onChange={(newval) => setAttributes({ hidesubtitle: newval })}
					/>

					<BoxControl 
						label={__('Margin','spice-blocks')}
						inputProps={{ min: -300 }}
						values={margins}
						sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(newValue) =>
							setAttributes({
								...margins,
								margins: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>

				    <BoxControl
						values={paddings}
						label={__('Box Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...paddings,
								paddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>					

					<BoxControl
						values={titlepaddings}
						label={__('Title Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...titlepaddings,
								titlepaddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>	

					<BoxControl
						values={subtitlepaddings}
						label={__('Subtitle Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...subtitlepaddings,
								subtitlepaddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>
					
					<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
						<ToggleControl
							label={__('Hide on Desktop','spice-blocks')}
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={__('Hide on Tablet','spice-blocks')}
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={__('Hide on Mobile','spice-blocks')}
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
		        		<SelectControl
				            label={__('Animation','spice-blocks')}
				            value={ animation }
				            options={ [
			            		{ label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
			            	] }
		            		onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
		        		/>  
				        { animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>
				</PanelBody>

				<PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>	
					<RangeControl 
						label={ __('Horizontal Shadow(px)','spice-blocks') }			    
					    value={ hshadow}
					    onChange={(newtext) => setAttributes({ hshadow: newtext })}
						min={0}
						max={100}
					/>
					<RangeControl 
						label={ __('Vertical Shadow(px)','spice-blocks') }			    
					    value={ vshadow}
			        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
						min={0}
						max={100}
					/>	
					<RangeControl 
						label={ __('Blur Shadow(px)','spice-blocks') }			    
					    value={ blurshadow}
			        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
						min={0}
						max={100}
					/>
					<PanelColorSettings  initialOpen={true}
						className='spice-block-section-bg-color'
						title={ __('Box Shadow Color','spice-blocks') }
						colorSettings={[
							{
							value: shadowColor,
							onChange: setShadowColor,
							label: __('Box Shadow:','spice-blocks')
							},
						]}
					/>
				</PanelBody>

				<PanelBody initialOpen={false} title={__('Color & Background Settings','spice-blocks')} >
					<PanelColorSettings  className={'spice-blocks-color-style'}
						colorSettings={[
							{
								value: titleColor,
								clearable: true,
								onChange: setTitle,
								label: __('Title Color','spice-blocks')
							},
							{
								value: subtitleColor,
								clearable: true,
								onChange: setSubtitle,
								label: __('Subtitle Color','spice-blocks')
							},
							
						]}
					/>				

					<div className="spice_block_section_flex_panel">
						<p className="spice_block_section_panel_label">
							{__('Background Image', 'spice-blocks')}
						</p>
						<div className="spice_block_section_panel">
							
							<Button
								isSmall={true}
								isPressed={bgType === 'image'}
								onClick={() =>
									setAttributes({
										bgType: 'image',
									})
								}
							>
								<svg width="18" height="15" viewBox="0 0 18 15">
									<path
										d="M16.083.263h-14.446c-.798 0-1.445.648-1.445 1.447v11.579c0 .8.646 1.447 1.445 1.447h14.446c.798 0 1.445-.648 1.445-1.447v-11.579c0-.8-.646-1.447-1.445-1.447zm-4.334 2.171c2.389 0 2.386 3.618 0 3.618-2.385 0-2.39-3.618 0-3.618zm-9.39 10.855l4.334-5.789 2.965 3.961 2.091-2.514 3.611 4.342h-13.001z"
										className="svg-fill"
										fillRule="nonzero"
									></path>
								</svg>
							</Button>
							
							<Button
								isSmall={true}
								onClick={() =>setAttributes({
												bgType: 'none',
											})
							}>
								<span className="dashicons dashicons-image-rotate"></span>
							</Button>
						</div>
					</div>
				{/* Image Background */}
				{bgType === 'image' && (
				    <Fragment>
				        {bgImage ? (
				            <Fragment>
				                <div className="spice_block_section_preview_container">
				                    <div className="spice_block_section_preview_image">
				                        <FocalPointPicker
				                            url={bgImage}
				                            value={bgImagePosition}
				                            onChange={(focalPoint) =>setAttributes({
									                                    bgImagePosition:
									                                    focalPoint,
									                                })
				                            }
				                        />
				                    </div>
				                    <div className="spice_block_section_preview_actions">
				                        <button
				                            onClick={() =>
				                                setAttributes({
				                                    bgImage: '',
				                                })
				                            }
				                        >
				                            <span className="dashicons dashicons-trash"></span>
				                        </button>
				                    </div>
			               		</div>
            				</Fragment>
					        ) : (
					            <MediaUpload
					                onSelect={(media) =>setAttributes({
									                        bgImage: media.url,
									                    })
					                }
					                type="image"
					                value={bgImage}
					                render={({ open }) => (
					                    <button
					                        className="spice_block_section_custom_upload"
					                        onClick={open}
					                    >
					                        <span className="dashicons dashicons-insert"></span>
					                        <span className="spice_block_section_upload_label">
					                            {__('Add Image', 'spice-blocks')}
					                        </span>
					                    </button>
					                )}
					            />
					        )
					    }
				        <div className="spice_block_section_flex_panel">
							<p className="spice_block_section_panel_label">
								{__('Enable Parallax','spice-blocks')}
							</p>
							<FormToggle
								checked={bgImageParallax}
								onChange={() =>
									setAttributes({
										bgImageParallax: !bgImageParallax,
									})
								}
							/>
						</div>
				        <SelectControl
							label={__('Background Size', 'spice-blocks')}
							options={[
								{
									label: __('Default', 'spice-blocks'),
									value: 'initial',
								},
								{
									label: __('Cover', 'spice-blocks'),
									value: 'cover',
								},
								{
									label: __('Contain', 'spice-blocks'),
									value: 'contain',
								},
								{
									label: __('Auto', 'spice-blocks'),
									value: 'auto',
								},
							]}
							onChange={(size) => {
								setAttributes({ bgImageSize: size });
							}}
							value={bgImageSize}
						/>
						<SelectControl
							label={__('Background Repeat', 'spice-blocks')}
							options={[
								{
									label: __('No Repeat', 'spice-blocks'),
									value: 'no-repeat',
								},
								{
									label: __('Repeat', 'spice-blocks'),
									value: 'repeat',
								},
								{
									label: __('Repeat X', 'spice-blocks'),
									value: 'repeat-x',
								},
								{
									label: __('Repeat Y', 'spice-blocks'),
									value: 'repeat-y',
								},
							]}
							onChange={(value) => {
								setAttributes({ bgImageRepeat: value });
							}}
							value={bgImageRepeat}
						/>
    				</Fragment>
				)}
				</PanelBody>
				<PanelBody title={__('Background Overlay','spice-blocks')} initialOpen={false}>
					<div className="spice_block_section_flex_panel">
						<p className="spice_block_section_panel_label">
							{__('Enable Overlay','spice-blocks')}
						</p>
						<FormToggle
							checked={bgImageOverlay}
							onChange={() =>
								setAttributes({
									bgImageOverlay: !bgImageOverlay,
								})
							}
						/>
					</div>
					{bgImageOverlay && (
						<Fragment>
							
							<PanelColorSettings  initialOpen={open}
								className={'sb-color-style'}
								title={ __('Overlay Color','spice-blocks') }
								colorSettings={[
									{
									value: bgOverlayColor,
									onChange: setOverlayColor,
									label: __('Overlay Color:','spice-blocks')
									},
								]}
							/>												
							<RangeControl
								label={__('Overlay Opacity','spice-blocks')}
								value={bgOverlayOpacity}
								onChange={(value) =>setAttributes({
														bgOverlayOpacity: value,
													})
								}
								min={0.1}
								max={1}
								step={0.01}
							/>
						</Fragment>
					)}
				</PanelBody>

				<PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')}>					    

		        	<PanelBody initialOpen={false} title={__('Title Font Typography','spice-blocks')}>    
		        		<BaseControl id="spice-blocks-font-family" label={__(' Font Family','spice-blocks')} __nextHasNoMarginBottom={ true }>
							<FontPicker
			                    apiKey="AIzaSyBH0F5UCzRyGQImf8sDK3UVo18kCeq_FqM"
			                    activeFontFamily={ titlefontfamily }
			                    limit={ 200 }
			                    onChange={ ( nextFont ) => setAttributes({
									                        titlefontfamily: nextFont.family
									                    }) 
			                	}
					        />
						</BaseControl>
			        	<FontSizePicker 
			        		__nextHasNoMarginBottom
				            value={ titlefontSize }
				            onChange={(userVal) => setAttributes({
														titlefontSize: userVal
													})
							}
			        	/>
			        	<SelectControl
				            label={__('Font Weight','spice-blocks')}
				            value={ titleFontWeight }
				            options={ [
				                { label: __('Thin','spice-blocks'), value: '100' },
				                { label: __('Extra Light','spice-blocks'), value: '200' },
				                { label: __('Light','spice-blocks'), value: '300' },
				                { label: __('Regular','spice-blocks'), value: '400' },
				                { label: __('Medium','spice-blocks'), value: '500' },
				                { label: __('Semi Bold','spice-blocks'), value: '600' },
				                { label: __('Bold','spice-blocks'), value: '700' },
				                { label: __('Extra Bold','spice-blocks'), value: '800' },
				                { label: __('Black','spice-blocks'), value: '900' },
				            ] }
				            onChange={ (newtext) => setAttributes({ titleFontWeight: newtext }) }
				        />
				        <RangeControl 
							label={__('line Height(px)','spice-blocks')}		    
					    	value={ titleLineHeight}
				        	onChange={(newtext) => setAttributes({ titleLineHeight: newtext })}
							min={0}
							max={100}
						/>
						<SelectControl
				            label={__('Transform','spice-blocks')}
				            value={ titleTransform }
				            options={ [
				              	{ label: __('Default','spice-blocks'), value: '' },
				                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
				                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
				                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
					            ] }
				            onChange={ (newtext) => setAttributes({ titleTransform: newtext }) }					  
			        	/>

				        <SelectControl
				            label={__('Decoration ','spice-blocks')}
				            value={ titleDecoration }
				            options={ [
								{ label: __('Default','spice-blocks'), value: '' },
								{ label: __('Underline','spice-blocks'), value: 'underline' },
								{ label: __('Overline','spice-blocks'), value: 'overline' },
								{ label: __('Line Through','spice-blocks'), value: 'line-through' },
							] }
				            onChange={ (newtext) => setAttributes({ titleDecoration: newtext }) }					  
				        />

				        <RangeControl 
							label={__('Letter Spacing','spice-blocks')}			    
						    value={ titleLetterSpacing}
				        	onChange={(newtext) => setAttributes({ titleLetterSpacing: newtext })}
							min={-10}
							step={0.1}
							max={10}
						/>

		        	</PanelBody>

		        	<PanelBody initialOpen={false} title={__('Subtitle Font Typography','spice-blocks')}>
				        <BaseControl id="spice-blocks-font-family" label={__(' Font Family','spice-blocks')} __nextHasNoMarginBottom={ true }>
							<FontPicker
			                    apiKey="AIzaSyBH0F5UCzRyGQImf8sDK3UVo18kCeq_FqM"
			                    activeFontFamily={ subtitlefontfamily }
			                    limit={ 200 }
			                    onChange={ ( nextFont ) => setAttributes({
			                        subtitlefontfamily: nextFont.family
			                    })}
					        />
						</BaseControl>
				        <FontSizePicker 
				        	__nextHasNoMarginBottom
				            value={ subtitlefontSize }
				            onChange={(val) => setAttributes({
								subtitlefontSize: val
							})}
				        />
				        <SelectControl
				            label="Font Weight"
				            value={ subtitleFontWeight }
				            options={ [
				              	{ label: __('Thin','spice-blocks'), value: '100' },
				                { label: __('Extra Light','spice-blocks'), value: '200' },
				                { label: __('Light','spice-blocks'), value: '300' },
				                { label: __('Regular','spice-blocks'), value: '400' },
				                { label: __('Medium','spice-blocks'), value: '500' },
				                { label: __('Semi Bold','spice-blocks'), value: '600' },
				                { label: __('Bold','spice-blocks'), value: '700' },
				                { label: __('Extra Bold','spice-blocks'), value: '800' },
				                { label: __('Black','spice-blocks'), value: '900' },
					            ] }
				            onChange={ (val) => setAttributes({ subtitleFontWeight: val }) }					  
				        />
				        <RangeControl 
							label={__('line Height(px)','spice-blocks')}			    
					    	value={ subtitleLineHeight}
			        		onChange={(val) => setAttributes({ subtitleLineHeight: val })}
								min={0}
								max={100}
						/>				        
				        <SelectControl
				            label={__('Transform','spice-blocks')}
				            value={ subtitleTransform }
				            options={ [
				              	{ label: __('Default','spice-blocks'), value: '' },
				                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
				                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
				                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
					            ] }
				            onChange={ (newtext) => setAttributes({ subtitleTransform: newtext }) }					  
			        	/>
				        <SelectControl
				            label={__('Decoration ','spice-blocks')}
				            value={ subtitleDecoration }
				            options={ [
				              	{ label: __('Default','spice-blocks'), value: '' },
				                { label: __('Underline','spice-blocks'), value: 'underline' },
				                { label: __('Overline','spice-blocks'), value: 'overline' },
				                { label: __('Line Through','spice-blocks'), value: 'line-through' },
					            ] }
				            onChange={ (newtext) => setAttributes({ subtitleDecoration: newtext }) }					  
				        />
				        <RangeControl 
							label={__('Letter Spacing','spice-blocks')}			    
						    value={ subtitleLetterSpacing}
				        	onChange={(newtext) => setAttributes({ subtitleLetterSpacing: newtext })}
							min={-10}
							step={0.1}
							max={10}
						/>
					</PanelBody>

		    	</PanelBody>					

			</InspectorControls>

			<BlockControls>
					<AlignmentToolbar
						value={attributes.textAlignment}
						onChange={(newalign) => setAttributes({ textAlignment: newalign })}
					/>
			</BlockControls>

			<div className={`${blockquoteclass} ${alignmentClass} ${animationclass} ${displayclass}`} id={uniqueid}>

	        { bgImageOverlay && (
					<div className={"spice-blocks-overlay"} style={{
							backgroundColor: bgImageOverlay
								? bgOverlayColor
								: '',
							opacity: bgImageOverlay ? bgOverlayOpacity : '',
						}}>
					</div>
			)}   

            <div class="block-container">
                <div class="block-row">
                    <div class="block-col-12">
                        <div class="cta-block">
                      		{ hideTitle &&(
                      		<Fragment> 
                      			<RichText
									key="editable"
									tagName="h2"
									className={"top-heading"}
									value={Title}
									onChange={(newvalue) => setAttributes({ Title: newvalue })}
									style={{}}
								/>
							</Fragment>
								)
							}
							{ hidesubtitle &&( 
							<Fragment>
								<RichText
									key="editable"
									className={"main-heading"}
									tagName="p"
									value={subtitle}
									onChange={(newvalue) => setAttributes({ subtitle: newvalue })}
								/>
							</Fragment>
								)
							}
                            
                          <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />
                        </div>
                    </div>
                </div>
            </div>
    	</div>									
		</Fragment>
		);
};
 

registerBlockType('spice-blocks/spice-call-to-action',{

	title:__('Call to Action','spice-blocks'),
	icon: <svg width="24" height="18" xmlns="http://www.w3.org/2000/svg"><g id="svg_7"><rect stroke="#09A223" id="svg_2" height="16.65616" width="24.84361" y="0.60944" x="0.57819" fill="#09A223"></rect><g id="svg_6"><rect id="svg_3" height="1.96874" width="8.43747" y="3.00002" x="8.28127" fill="#fff"></rect><rect id="svg_4" height="1.56249" width="18.37491" y="6.90629" x="3.31255" fill="#fff"></rect><rect id="svg_3" height="1.96874" width="4.43747" y="12.00002" x="8.28127" fill="#fff"></rect><rect id="svg_3" height="1.96874" width="4.43747" y="12.00002" x="14.28127" fill="#fff"></rect></g></g></svg>,
	example: {
      'attributes' : {
          'mode' : 'preview',
      }
  	},
	category:'spice-blocks',
	keywords:['Spice Call To Action','cta', 'CTA'],
	attributes:{
		uniqueid:{
			type:'string'
		},
		hideTitle:{
			type:'boolean',
			default:true,
		},
		hidesubtitle:{
			type:'boolean',
			default:true,
		},
		subtitle:{
			type:'string',
			default:'Duis aute irure dolor in reprehe nderit in voluptate velit esse cillum'
		},
		Title:{
			type:'string',
			default:'Occaecat cupidatat non proident'
		},
		textAlignment: {
			type: 'string',
			default:'center'
		},
		subtitleColor:{
			type:'string',
		},
		bgColor:{
	    	type:'string',
	    },
		titleColor:{
			type:'string',
		},
		shadowColor:{
			type:'string',
			default:'#000'
		},
		boxColor:{
			type:'string',
		},
		quoteColor:{
			type:'string',
		}, 
		bgType: {
			type: 'string',
			default: 'none'
		},
		bgImage: {
			type: 'string',
		},
		bgImageParallax: {
			type: 'boolean',
			default: false
		},
		bgImageSize: {
			type: 'string',
			default: 'cover'
		},
		bgImageRepeat: {
			type: 'string',
			default: 'no-repeat'
		},
		bgImageOverlay: {
			type: 'boolean',
			default: true
		},
		bgOverlayColor: {
			type: 'string',
			default: '#000000'
		},
		bgOverlayOpacity: {
			type: "number",
			default: 0.7
		},
		bgImagePosition: {
			type: 'object',
			default: {
				"x": 0.5,
				"y": 0.5
			}
		},
		margins: {
	      default: {
		        top: '0px',
		        left: '0px',
		        right: '0px',
		        bottom: '0px'
	      }
		},
		paddings:{
			type: 'object',
			default: {
				top: '172px',
				left: '10px',
				right: '10px',
				bottom: '206px',
			},
		},
		subtitlepaddings:{
			type: 'object',
		    default: {
		        top: '5px',
		        left: '10px',
		        right: '10px',
		        bottom: '5px',
		    },
		},
		titlepaddings:{
			type: 'object',
		    default: {
			      top: '0px',
			      left: '0px',
			      right: '0px',
			      bottom: '0px',
		    },
		},
		opacity:{
			type:'number',
			default:0.5
		},
		hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
	  	hidedesktop:{
    		type: 'boolean',
			default: false
	    },
	    hidetablet:{
	    	type: 'boolean',
				default: false
	    },
	    hidemobile:{
	    	type: 'boolean',
				default: false
	    },
	    animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    },
	    titlefontfamily:{
	    	type:'string',
	    	default:'Open Sans'
	    }, 
	    titlefontSize:{
				type:'string',
			},
			titleFontWeight:{
				type:'string',
			},
			titleLineHeight:{
	    	type:'number',
	    },
		titleTransform:{
	    	type:'string'
	    },
	    titleDecoration:{
	    	type:'string'
	    },
	    titleLetterSpacing:{
	    	type:'number'
	    },
	    subtitlefontfamily:{
	    	type:'string',
	    	default:'Open Sans'
	    }, 
	    subtitlefontSize:{
				type:'string',
			},
		subtitleFontWeight:{
			type:'string',
		},	
	    subtitleLineHeight:{
	    	type:'number',
	    },
	    subtitleTransform:{
	    	type:'string'
	    },
	    subtitleDecoration:{
	    	type:'string'
	    },
	    subtitleLetterSpacing:{
	    	type:'number'
	    },
    
	},

	edit:withSelect((select, props) => {
		return { media: props.attributes.mediaId ? select('core').getMedia(props.attributes.mediaId) : undefined };
	})(BlockEdit),

	save:(props)=>{
		const { attributes } = props;
		const{ uniqueid, bgType, boxColor, quoteColor, shadowColor, subtitle, subtitlepaddings, subtitleborderRadius, titlepaddings, Title, subtitleColor, subtitlebgColor, bgColor, titleColor, bgimgrepeat, bgimgposition, bgimgsize, bgimgattch, margins, paddings, opacity, subtitlefontfamily,  subtitlefontSize, subtitleLineHeight, subtitleFontWeight, subtitleTransform, subtitleDecoration, subtitleLetterSpacing, titlefontfamily,  titlefontSize, titleFontWeight, titleLineHeight, titleTransform, titleDecoration, titleLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bgImage, bgImageParallax, bgImageSize, bgImageRepeat, bgImageOverlay, bgOverlayColor, bgOverlayPopup, bgOverlayOpacity, bgVideo, bgImagePosition, hideTitle, hidesubtitle}=attributes;
		
		const blockquoteclass='wp-block background-img spice-blocks-cta cta';
		const blockStyle = plugin.pluginpath + 'assets/images/cta.jpg';
		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass='animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop=(hidedesktop != false) ? 'hide-desktop' : '';
		const displaytablet=(hidetablet != false) ? 'hide-tablet' : '';
		const displaymobile=(hidemobile != false) ? 'hide-mobile' : '';
		const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
		
		let containerBg = '';

		if (bgType !== 'none' && bgType === 'image') {
			containerBg = `url(${bgImage})`;		
		} else {
			containerBg = `url(${blockStyle})`;
		}

		let backgroundPosition = '';
		if(bgType === 'image' && bgImage)
		{
			backgroundPosition =`${bgImagePosition.x * 100}% ${ bgImagePosition.y * 100 }%`
		}
		else
		{
			backgroundPosition = '';
		}

		let backgroundSize = '';
		if(bgType === 'image' && bgImage)
		{
			backgroundSize = bgImageSize;
		}
		else
		{
			backgroundSize = '';
		}

		//Image Background Attachment
		let backgroundAttachment = '';
		if(bgType === 'image' && bgImage && bgImageParallax)
		{
			backgroundAttachment='fixed';
		}
		else
		{
			backgroundAttachment='scroll';
		}	
		
		//Background Image Repeat
		let backgroundRepeat = '';
		if(bgType === 'image' && bgImage)
		{
			backgroundRepeat = bgImageRepeat;
		}
		else
		{
			backgroundRepeat = '';
		}

		return(
		<>	
			<script> 
				var fontfamily2=`{titlefontfamily}`;
				var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var link2 = document.createElement('link');
				link2.href = url2;
				link2.rel = "stylesheet";
				link2.type =  "text/css";	          
				document.head.appendChild(link2);
				
				var subtitlefontfamily2=`{subtitlefontfamily}`;				
				var subtitlefontfamilyurl2 = 'https://fonts.googleapis.com/css2?family='+subtitlefontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var subtitlefontfamilylink2 = document.createElement('link');
				subtitlefontfamilylink2.href = subtitlefontfamilyurl2;
				subtitlefontfamilylink2.rel = "stylesheet";
				subtitlefontfamilylink2.type =  "text/css";	          
				document.head.appendChild(subtitlefontfamilylink2);
			</script>
			<style dangerouslySetInnerHTML={{
			  __html: [
			    `.spice-blocks-cta#${uniqueid}{
			     	background-image: ${containerBg};					
			    	margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
					padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
					box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
					animation-delay: ${delay}ms;
					background-position: ${backgroundPosition}; 
					background-repeat: ${bgImageRepeat};
					background-size:${backgroundSize};
					background-attachment: ${backgroundAttachment};
					background-repeat: ${backgroundRepeat};
			     }
			    #${uniqueid} .top-heading{
			     	color:${titleColor};
					font-size: ${titlefontSize};
					font-weight: ${titleFontWeight};
					line-height: ${titleLineHeight}px;
					font-family: ${titlefontfamily};
					text-transform: ${titleTransform};
					text-decoration: ${titleDecoration};
					letter-spacing: ${titleLetterSpacing}px;
					padding: ${titlepaddings.top} ${titlepaddings.right} ${titlepaddings.bottom} ${titlepaddings.left};
					}
			    #${uniqueid} p.main-heading{
						color:${subtitleColor};
						font-size: ${subtitlefontSize};
						font-weight: ${subtitleFontWeight};
						line-height: ${subtitleLineHeight}px;
						font-family: ${subtitlefontfamily};
						text-transform: ${subtitleTransform};
						text-decoration: ${subtitleDecoration};
						letter-spacing: ${subtitleLetterSpacing}px;
						padding: ${subtitlepaddings.top} ${subtitlepaddings.right} ${subtitlepaddings.bottom} ${subtitlepaddings.left};
				}`
			    ].join('\n')
			  }}>
			</style>
			<div className={`${blockquoteclass} ${alignmentClass} ${animationclass} ${displayclass} ${props.attributes.className}`} id={uniqueid} 
			>
			{ bgImageOverlay && (
					<div className={"spice-blocks-overlay"} style={{
							backgroundColor: bgImageOverlay
								? bgOverlayColor
								: '',
							opacity: bgImageOverlay ? bgOverlayOpacity : '',
						}}>
					</div>
			)}            
            <div class="block-container">
                <div class="block-row">
                    <div class="block-col-12">
                        <div class="cta-block">
                        	{ hideTitle &&(
                        	<Fragment>
					            <RichText.Content
									className={"top-heading"}
									tagName="h2"									
									value={Title}
									style={{}}
								/>
							</Fragment>
								)
							}
							{ hidesubtitle &&(
							<Fragment>
				          		<RichText.Content
									className={"main-heading"}
									tagName="p"
									value={subtitle}
								/>
							</Fragment>
								)
							}
							<InnerBlocks.Content />
                      	</div>
                  	</div>
              	</div>
          	</div>
  		</div>					
		</>
		)
	}
})